<template>
	<el-container>
	
		<el-form :model="formNew" ref="formNew" label-width="150px" class="demo-form-inline" size="medium" style="width:96%;">
				<el-form-item label="所属组织" prop="parent">
        	<el-input v-model="formNew.parent" autocomplete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="巡检路线名称" prop="patrolroad_name">
        	<el-input v-model="formNew.patrolroad_name" autocomplete="off"></el-input>
      	</el-form-item>
      	<el-form-item label="巡检账号" prop="patrolroad_accounts">
        	<el-transfer v-model="filterAccount.value" :titles="['待选账号', '已选账号']" :data="filterAccount.data"></el-transfer>
      	</el-form-item>
      	<el-form-item label="周期模式">
      			<el-radio v-model="rdoCycleMode" label="1" border size="medium">每天重复</el-radio>
				    <el-radio v-model="rdoCycleMode" label="2" border size="medium">每周重复</el-radio>
				    <el-radio v-model="rdoCycleMode" label="3" border size="medium">每月重复</el-radio>
      	</el-form-item>
      	<el-form-item label="每周重复" v-show="rdoCycleMode == '2'">
          	<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
				    <div style="margin: 15px 0;"></div>
				    <el-checkbox-group v-model="checkedWeeks" @change="handleCheckedWeeksChange">
				    	<el-checkbox v-for="week in weeks" :label="week" :key="week">{{week}}</el-checkbox>
				  	</el-checkbox-group>
      	</el-form-item>
      	<el-form-item label="每月重复" v-show="rdoCycleMode == '3'">
          	<el-checkbox :indeterminate="isMonthIndeterminate" v-model="checkMonthDaysAll" @change="handleCheckAllMonthDaysChange">全选</el-checkbox>
				    <div style="margin: 15px 0;"></div>
				    <el-checkbox-group v-model="checkedMonthDays" @change="handleCheckedMonthDaysChange">
				    	<el-checkbox v-for="day in monthDays" :label="day" :key="day">{{day}}</el-checkbox>
				  	</el-checkbox-group>
      	</el-form-item>
      	<el-form-item label="开始-结束时间" prop="time">
          <el-time-select
				    placeholder="起始时间"
				    v-model="formNew.startTime"
				    :picker-options="{
				      start: '08:30',
				      step: '00:15',
				      end: '18:30'
				    }">
			  	</el-time-select>
				  	&nbsp;&nbsp;
				  <el-time-select
				    placeholder="结束时间"
				    v-model="formNew.endTime"
				    :picker-options="{
				      start: '08:30',
				      step: '00:15',
				      end: '18:30',
				      minTime: formNew.startTime
				    }">
				  </el-time-select>
      	</el-form-item>
      	<el-form-item label="巡检项名称" prop="road_line">
        	<el-transfer v-model="transferCard.value" :titles="['待选巡检项', '已选巡检项']" :data="transferCard.data"></el-transfer>
      	</el-form-item>
      	<el-form-item label="备注" prop="remark">
        	<el-input type="textarea" v-model="formNew.remark"></el-input>
        </el-form-item>
      	<el-form-item>
			    <el-button @click="dialogFormVisible = false">取 消</el-button>
  				<el-button type="primary" @click="saveData()">保 存</el-button>
			  </el-form-item>
		</el-form>

	</el-container>
</template>

<script>
import Api from '../../api/index'

const weekOptions = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];
const monthOptions = [];
for(var i=1; i<=31; i++) {
	monthOptions.push(`${i}号`);
}

export default {
  name: "PatrolRoadForm",
  data() {
    return {
        dialogFormVisible: false,
        parent_id: 0,
        rdoCycleMode: "1",
        checkAll: false,
        checkMonthDaysAll: false,
        weeks: weekOptions,
        checkedWeeks: ['周一', '周二', '周三', '周四', '周五'],
        monthDays: monthOptions,
        checkedMonthDays: [],
        isIndeterminate: true,
        isMonthIndeterminate: true,
        formNew: {
        	road_id: 0,
        	hold_id: 0,
        	parent: "",
        	patrolroad_name: "",
        	startTime: "",
        	endTime: "",
        	remark: ""
        },
        filterAccount: {
        	data: [],
        	value: []
        },
        transferCard: {
        	data: [],
        	value: []
        }
    };
  },
  methods: {
  	handleCheckAllChange(val) {
	    this.checkedWeeks = val ? weekOptions : [];
	    this.isIndeterminate = false;
    },
    handleCheckAllMonthDaysChange(val) {
	    this.checkedMonthDays = val ? monthOptions : [];
	    this.isMonthIndeterminate = false;
    },
    handleCheckedWeeksChange(value) {
        let checkedCount = value.length;
        this.checkAll = checkedCount === this.weeks.length;
        this.isMonthIndeterminate = checkedCount > 0 && checkedCount < this.weeks.length;
    },
    handleCheckedMonthDaysChange(value) {
        let checkedCount = value.length;
        this.checkMonthDaysAll = checkedCount === this.monthDays.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.monthDays.length;
    },
    show: function(id, parent_id) {
        this.dialogFormVisible = true;
        this.parent_id = parent_id;

      	//加载所属用户名
      	Api.LoadParentBase({ id: this.parent_id }).then(res => {
          if(!res && res.code !== 200)
            return;

          if(res.data) {
            this.formNew.hold_id = res.data.hold_id;
            this.formNew.parent = res.data.hold_name;
          }
        });

        this.delegInitAccountOptions(parent_id);
    },
    delegInitAccountOptions: function(parentId) {
    		//加载账号选项
        this.filterAccount.data = [];
        Api.GetAccountOptions({ hold_id: parentId }).then(res => {
        	if(!res && res.code !== 200)
            return;

          for(var i=0; i<res.data.length; i++) {
          	this.filterAccount.data.push({
	            label: res.data[i].true_name + "/" + res.data[i].user_name,
	            key: res.data[i].user_id,
	            id: res.data[i].user_id
	          });
          }

          this.delegInitPatrolCardOptions(parentId);
        });
    },
    delegInitPatrolCardOptions: function(parentId) {
    		//加载巡检项
        this.transferCard.data = [];
        Api.GetCardOptions({ hold_id: parentId }).then(res => {
        	if(!res && res.code !== 200)
            return;

          for(var i=0; i<res.data.length; i++) {
          	this.transferCard.data.push({
	            label: res.data[i].patrol_name,
	            key: res.data[i].patrol_id,
	            id: res.data[i].patrol_id
	          });
          }

          var id = this.$route.query.id;
          if(id > 0)
          	this.delegInitPatrolDetail(id);
        });
    },
    delegInitPatrolDetail: function(roadId) {
    		// 加载线路详情数据
      	Api.GetPatrolDetail({ roadId: roadId }).then(res => {
      		if(!res && res.code !== 200)
          	return;

          this.formNew.road_id = res.data.road_id;
          this.formNew.patrolroad_name = res.data.road_name;
          this.formNew.startTime = res.data.start_time;
          this.formNew.endTime = res.data.end_time;
          this.formNew.remark = res.data.remark;
          if(res.data.user_id)
          	this.filterAccount.value.push(res.data.user_id);
          if(res.data.patrol_card_ids) {
	          var cs = res.data.patrol_card_ids.split(',');
	          for(var c=0; c<cs.length; c++) {
	          	if(!cs[c])
	          		continue;
	          	this.transferCard.value.push(parseInt(cs[c]));
	          }
	          console.log(`trans cards: ${this.transferCard.value}.`);
	        }

          if(res.data.cycle_everydays === 1) {
          	// 每天重复
          	this.rdoCycleMode = '1';
          } else if (res.data.cycle_weeks) {
          	// 每周重复
          	this.rdoCycleMode = '2';
          	this.checkedWeeks = res.data.cycle_weeks.split(',');
          } else if (res.data.cycle_monthdays) {
          	// 每月重复
          	this.rdoCycleMode = '3';
          	this.checkedMonthDays = res.data.cycle_monthdays.split(',');
          }

      	});
    },
    saveData: function() {

    	if(!this.formNew.patrolroad_name ||
    			this.formNew.patrolroad_name.length === 0) {
    		this.$message.error('请输入路线名称！');
    		return;
    	}
    	if(this.filterAccount.value.length === 0) {
    		this.$message.error('请选择账号！');
    		return;
    	}
    	if(this.transferCard.value.length === 0) {
    		this.$message.error('请选择巡检项！');
    		return;
    	}

    	var repeatItems = "";
    	if(this.rdoCycleMode === "2") {
    		repeatItems = this.checkedWeeks.join(",");
    	} else if(this.rdoCycleMode === "3") {
    		repeatItems = this.checkedMonthDays.join(",");
    	}

    	var argdata = {
    		road_id: this.formNew.road_id,
    		road_name: this.formNew.patrolroad_name,
    		hold_id: this.formNew.hold_id,
    		cycle_repeat_type: parseInt(this.rdoCycleMode),
    		cycle_repeat_items: repeatItems,
    		remark: this.formNew.remark,
    		user_id_list: this.filterAccount.value,
    		card_id_list: this.transferCard.value
    	};
    	if(this.formNew.startTime) {
    		argdata.start_time = this.formNew.startTime;
    	}
    	if(this.formNew.endTime) {
    		argdata.end_time = this.formNew.endTime;
    	}
    	Api.SaveRoadInfo(argdata).then(res => {
    			if(!res) {
	          this.$message.error('出错了！');
	          return;
	        }

	        if(res.code !== 200) {
	          this.$message.error(res.msg);
	          return;
	        }

	        console.log(res);

	        if(this.formNew.road_id > 0) {
	          this.$confirm('恭喜你，提交成功！是否继续?', '提示', {
		          confirmButtonText: '确定',
		          cancelButtonText: '关闭',
		          type: 'success',
		          center: true
		        }).then(() => {
		          //继续新增
		        }).catch(() => {
		          //回到页面
		          window.close();
		        });
	        } else {
	        		this.$confirm('恭喜你，新增成功！是否继续?', '提示', {
			          confirmButtonText: '确定',
			          cancelButtonText: '关闭',
			          type: 'success',
			          center: true
			        }).then(() => {
			          //继续新增
			          this.formNew.patrolroad_name = "";
			          this.filterAccount.value = [];
			          this.transferCard.value = [];
			          this.formNew.remark = "";
			        }).catch(() => {
			          //回到页面
			          window.close();
			        });
	        }

    	});
    }
  },
  mounted() {
  	let id = this.$route.query.id;
  	let hold_id = this.$route.query.holdid;
  	console.log(`road_id: ${id}, holdid: ${hold_id}`);
  	this.show(id, hold_id);
  }
}
</script>

<style>
	#box_accounts {
		padding-top: 5px;
		padding-left: 10px;
		border-color: #dddddd;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	}
	.account-box-edit-btn {
		margin-bottom: 10px;
	}
</style>